/**
 * The Staff class acts as the view object for the staff.
 */
const tbs_model_vo_MatchStaff = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchStaff.prototype = {
    /* The view object name */
    name: 'matchStaff',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetUnionManageMatchList2',
            basePath: 'data.list',
            rule: {
                matchId: 'id',
                matchName: 'chineseName',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'addContactMatch',
            basePath: '',
            rule: {
                matchId: 'matchId',
                contactId: 'staffId',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'deleteContactMatch',
            basePath: '',
            rule: {
                matchId: 'matchId',
                contactId: 'staffId',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
}

module.exports = tbs_model_vo_MatchStaff